import React, { useState } from 'react';
import cx from 'classnames';

import Modal from './modal';
import Button from '~/components/button';

import styles from './modal.module.scss';

const ConfirmModal = ({
  isOpen,
  onClose,
  onSelection,
  title = '',
  text = '',
  cancelButtonTitle = 'No',
  confirmButtonTitle = 'Yes',
  showCancelButton = true,
}) => {
  const [isExecuting, setIsExecuting] = useState(false);

  const handleConfirm = async () => {
    setIsExecuting(true);
    await onSelection(true);
    setIsExecuting(false);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} allowClose={true}>
      <div style={{ maxWidth: '38rem' }}>
        <h2 className={styles.title} style={{ fontSize: '2.8rem' }}>
          {title}
        </h2>
        <div className={styles.text}>{text}</div>

        <div
          className={cx(
            showCancelButton
              ? styles.confirmButtonsFooter
              : styles.confirmButtonsFooterCentered
          )}
        >
          {showCancelButton && (
            <Button
              type="button"
              variant="outline"
              onClick={() => onSelection(false)}
            >
              {cancelButtonTitle}
            </Button>
          )}
          <Button type="button" onClick={handleConfirm} isLoading={isExecuting}>
            {confirmButtonTitle}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
